export default "__VITE_ASSET__CElfmU8W__"